export const validateImportFile = (keys: string[]) => {
  if (keys.includes('phonetic_first_name')) {
    return "AgePhoneAddress";
  }
  else if (keys.includes('contactName')) {
    return "WidefoneAddress";
  }
  else if (keys.includes('display_name')) {
    return "YealinkAddress";
  }
  else if (keys.includes('名称')){
    return "CloudbizAddress";
  }
  else {
    return "InvalidAddress";
  }
}
